




























































































import Modal from "../core/Modals/Modal.vue";
import { ControleVehiculeApi } from "../api/ControleVehiculeApi";
import { EntretienVehicule } from "../models/ControleVehicule";

export default {
    name: "EntretienList",
    components: { Modal },
    props: {
        showModal: Boolean,
        vehicule: Object,
    },
    data() {
        return {
            entretiens: [],
            form: new EntretienVehicule(),
            loading: false,
            saving: false,
            api: new ControleVehiculeApi(),
        };
    },
    methods: {
        load() {
            if (!this.vehicule) {
                return;
            }
            this.loading = true;
            this.api
                .getEntretiens({ vehicule_id: this.vehicule.id })
                .then((res) => {
                    this.entretiens = res;
                    this.loading = false;
                });
        },
        add() {
            this.form.vehicule_id = this.vehicule.id;
            this.saving = true;
            this.api.saveEntretien(this.form).then(() => {
                this.saving = false;
                this.form = new EntretienVehicule();
                this.load();
            });
        },
        remove(entretien) {
            this.api.removeEntretien(entretien.id).then(() => this.load());
        },
        close() {
            this.$emit("close-modal");
        },
    },
    watch: {
        vehicule: {
            immediate: true,
            handler(v) {
                if (v) {
                    this.form = new EntretienVehicule();
                    this.load();
                }
            },
        },
    },
};
